import { InjectionToken } from '@angular/core';

export interface IWebElementPrinter {
  print(title: string, additionalStyles?: string): void;
}

export const WEB_ELEMENT_PRINTER = new InjectionToken<IWebElementPrinter>('Interface for printing web elements');

export const DEFAULT_PRINT_STYLES = ` 
body {     
    font-family: Open Sans, sans-serif !important;
    height: auto;
}
* {
    overflow: visible !important;
    color: inherit !important;
    opacity: inherit !important;
}
hr {
    border-top: solid 1px black !important;
}
`;
